mutation CreateEventCampaign($eventId: ID!) {
  createEventCampaign(input: { eventId: $eventId }) {
    event {
      id
      campaign {
        id
      }
    }
  }
}
